import UltMeta, { Meta } from "./UltMeta";

/**
 * 文章类型
 */
class ArticleType extends UltMeta {
    ABOUT_US = new Meta(1, "关于我们");
    USER_AGREEMENT = new Meta(2, "用户协议");
    PRIVACY_AGREEMENT = new Meta(3, "隐私政策");
    MEMBER_AGREEMENT = new Meta(4, "会员服务协议");
    INFO_SERVICE_AGREEMENT = new Meta(6, "信息服务费协议");
    CONTACT_US = new Meta(7, "联系我们");
}
export const ARTICLE_TYPE = new ArticleType();
class AppType extends UltMeta {
    THREE_TERMINAL = new Meta(1, "三端");
    CARRYING_AGREEMENT = new Meta(2, "承运端");
    PC_WEB = new Meta(3, "用户PC端");
}

export const APP_TYPE = new AppType();
